import { loan_application_api } from '@axo/shared/data-access/api';
import { loan_application, Partner } from '@axo/shared/data-access/types';
import { Handler } from '../api-orchestrator';
import { IPreconditions } from '../types/IPreconditions';

interface IDependencies {
  postLead: typeof loan_application_api.postLead;
  deleteLead: typeof loan_application_api.deleteLead;
}

export const leadHandlerFactory =
  ({
    postLead,
    deleteLead,
  }: IDependencies): Handler<loan_application.CreateLead, IPreconditions> =>
  async ({
    data,
    preconditions: { customerId, customerJWT, loanApplicationId, ids },
    baseUrl,
    frontendId,
  }) => {
    if (!customerId || !customerJWT || !loanApplicationId) {
      return { didSync: false };
    }

    const partner = frontendId.split('/')[1];

    if (!(partner in Partner)) {
      throw new Error(`Lead partner:"${partner}" not found in partners list`);
    }

    data.Partner = Partner[partner as keyof typeof Partner];

    const id = ids.leads?.[frontendId];
    const api = { url: { service: baseUrl }, token: customerJWT };

    if (id) {
      if (!data.Consent) {
        await deleteLead(api)(loanApplicationId, data.Partner);
        delete ids.leads?.[frontendId];
        return {
          didSync: true,
          newPreconditions: {
            ids,
          },
        };
      }

      return {
        didSync: true,
      };
    }

    if (!data.Consent) {
      return { didSync: false };
    }

    const lead = await postLead(api)(loanApplicationId, data.Partner);

    return {
      didSync: true,
      newPreconditions: {
        ids: {
          ...ids,
          leads: {
            ...ids.leads,
            [frontendId]: lead.ID,
          },
        },
      },
    };
  };
